import { Component, OnInit, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';

// file upload stuff
import { EventEmitter, Output } from '@angular/core';
import { FileQueueObject, FileUploaderService } from '@app/core/services/file-uploader.service';
import { Observable } from 'rxjs/Observable';
import { Project } from '@app/shared';


@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss']
})
export class UploadDialogComponent implements OnInit {

  validFiles =['text/csv','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
  project:Project;
//  dialogFormGroup: FormGroup;
  success:boolean = false;
  isUploading:boolean = false;
  uploadsComplete = false;
  //@ViewChild('notifyForm') notifyForm;
  @Output() onCompleteItem = new EventEmitter();

  @ViewChild('fileInput') fileInput;
  queue: Observable<FileQueueObject[]>;

  fileQ:any = [];

  columns = [
    { prop: 'name', name:'name' },
    { prop: 'size', name:'size' },
    { prop: 'progress', name:'Progress' },
    { prop: 'actions', name: 'actions' },
  ];

  dropzoneActive:boolean = false;
  constructor(
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    private fb: FormBuilder,
    public uploader: FileUploaderService
  ) {

    this.project = data.project;
    // this.dialogFormGroup = new FormGroup({
    //   contacts : new FormControl('',[Validators.required]),
    //   subject : new FormControl('', [Validators.required]),
    //   msg : new FormControl('', [Validators.required]),
    // });

  }
  @HostListener('drop', ['$event'])
    onDrop($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.dropzoneActive = false;
      this.handleDrop($event.dataTransfer);
      // let transfer = $event.dataTransfer;
      // this.filesDropped.emit(transfer.files);
      // this.filesHovered.emit(false);
    }

    @HostListener('dragover', ['$event'])
     onDragOver($event) {
       $event.preventDefault();
       $event.stopPropagation();
       this.dropzoneActive = true;
     }

   @HostListener('dragleave', ['$event'])
    onDragLeave($event) {
      $event.preventDefault();
      $event.stopPropagation();
      //this.filesHovered.emit(false);
      this.dropzoneActive =  false;
    }

    uploadFiles():void{
      this.isUploading = true;
      this.uploader.uploadAll(this.project);
    }
    handleDrop(fileList: any) {
        var files = [];
        // check the files for only csv and doens't exist

        for(let file of fileList.files){
          var valid = true;
          if(this.validFiles.indexOf(file.type) === -1)
            valid = false;

          if(valid){
            this.fileQ.map(qfile => {

              if(file.name === qfile.file.name)
                valid = false;
            })
          }

          if(valid)
            files.push(file);

        }
        this.uploader.addToQueue(files);
    // let filesIndex = _.range(fileList.length)
    //
    // _.each(filesIndex, (idx) => {
    //   this.currentUpload = new Upload(fileList[idx]);
    //   this.upSvc.pushUpload(this.currentUpload)}
    // )
    }



  ngOnInit() {
    this.queue = this.uploader.queue;
    this.uploader.onCompleteItem = this.completeItem;

    this.queue.subscribe(val => this.fileQ = val);

  }

  completeItem = (item: FileQueueObject, response: any) => {

    this.onCompleteItem.emit({ item, response });
    let isComplete : boolean = true;
    for(let fqi of this.fileQ){
      if(fqi.progress < 100){
        isComplete = false;
      }
    }

    if(isComplete){
      setTimeout(_ => {
        this.uploader.clearQueue();
        this.isUploading = false;
        },800)
    }

    setTimeout(_ => {
      this.uploadsComplete = isComplete;
    },800)
  }

  addToQueue() {

    const fileBrowser = this.fileInput.nativeElement;
    this.uploader.addToQueue(fileBrowser.files);

    this.uploadsComplete = false;
  }

  canUpload():boolean{
    return (this.fileQ.length && !this.uploadsComplete && !this.isUploading) ;
  }
  onSubmit(){

    this.success = true;
    // if(this.projectFormGroup.valid){
    //   this.project = this.prepareSaveProject();
    //
    //   const payload = {project:this.project};
    //   this.store.dispatch(new UpdateProject(payload));
    // }
  }

  close():void{

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/upload-dialog/upload-dialog.component.ts